import * as THREE from 'three'

export default class Scene {
  public readonly scene: THREE.Scene
  public constructor() {
    this.scene = new THREE.Scene()
    // ----------------------------------------
    // 光源を追加する。
    // ----------------------------------------
    // 平行光源、環境光源を合わせて使用する。
    // 平行光源は太陽光のように影を作る。光が当たらない裏面が描画されないため、散乱して均等にあたる環境光源を合わせる。
    const baseLightColor = 0xffffff // 白
    const lightIntensity = 0.8 // 強さ
    const light = new THREE.DirectionalLight(baseLightColor, lightIntensity)
    light.position.set(-100, 200, 200) // x = -0.7, y = -0.7, z = 0.7 = 左斜め上からの光源
    light.castShadow = true // 影の描画を有効にする。
    // 影を出すためのパラメータを調整。光源の広さ。
    light.shadow.camera.top = 100
    light.shadow.camera.bottom = -100
    light.shadow.camera.left = 100
    light.shadow.camera.right = -100
    light.shadow.mapSize.width = 2000
    light.shadow.mapSize.height = 2000
    this.scene.add(light)
    // 少し暗めの環境光源を平行光源と同じ位置から当てる。
    const ambientLightColor = 0xffffff
    const ambient = new THREE.AmbientLight(ambientLightColor, 0.3)
    ambient.position.set(light.position.x, light.position.y, light.position.z)
    this.scene.add(ambient)
    // ----------------------------------------
    // ヘルパーを追加。
    // ----------------------------------------
    // const gridHelper = new THREE.GridHelper(200, 20)
    // this.scene.add(gridHelper)
    // const axis = new THREE.AxesHelper(1000)
    // axis.position.set(0, 0, 0)
    // this.scene.add(axis)
    // const directionalLightHelper = new THREE.DirectionalLightHelper(light)
    // this.scene.add(directionalLightHelper)
    // const directionalLightShadowHelper = new THREE.CameraHelper(light.shadow.camera)
    // this.scene.add(directionalLightShadowHelper)
  }

  public clear(): void {
    for (var i = this.scene.children.length - 1; i >= 0; i--) {
      var object = this.scene.children[i]
      if (object.type === 'Mesh' || object.type === 'Group') {
        this.scene.remove(object)
      }
    }
  }

  public add(...object: THREE.Object3D[]): void {
    this.scene.add(...object)
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Scene.ts